import React, { useEffect, useState } from 'react';
import s from '../../styles/corporate/Corporate.module.css';

/** 한 화면 넘게 내려가면 나타나는 '맨 위로' 버튼 */
const SHOW_AFTER = 600;

const CorpTopButton = () => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > SHOW_AFTER);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      className={`${s.topBtn} ${shown ? s.topBtnOn : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      // 숨어 있는 동안에는 탭 이동·읽기 대상에서 뺀다
      aria-hidden={shown ? undefined : 'true'}
      tabIndex={shown ? 0 : -1}
      title="맨 위로"
    >
      <span className={s.topBtnArrow} aria-hidden="true">
        ↑
      </span>
      <span className={s.topBtnLabel} translate="no">
        TOP
      </span>
    </button>
  );
};

export default CorpTopButton;
